const configuration = {
    en: {
        configuration: {
            errors: {
                input: {
                    required_field: "field is required",
                    invalid_input: {
                        number: "field must be a number",
                        weight_lenght: "field must be less than 100"
                    }
                }
            },
            output_metrics: {
                none: "None",
                impressions: "Impressions",
                grps: "GRPs",
                ave: "AVE"
            },
            custom_score: {
                average: "Average",
                sum: "Sum"
            },
            general: "General",
            categories: "Categories",
            tags: "Tags",
            relations: "Relations",
            households: "Households",
            breakdowns: "Breakdowns",
            automated_tags: "Automated Tags",
            scoring: "Scoring",
            ai_coding: "AI Coding"
        }
    }
}

module.exports.configuration = configuration;